import React from 'react';
import { TestimonialType } from 'types';
import styled from 'styled-components';
import { media, mixins, theme } from 'styles';

const Wrapper = styled.div`
  position: relative;
  padding-top: 80px;
  padding-left: 50px;

  ${media.tablet`
    padding-top: 110px;
    padding-left: 100px;
  `};
`;

const Logo = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  background-image: url('${props => props.imageUrl}');
  background-size: contain;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  width: 90px;
  height: 90px;

  ${media.tablet`
    width: 135px;
    height: 135px;
  `};
`;

// prettier-ignore
const Content = styled.div`
  ${mixins.paragraphText}
  position: relative;
  z-index: 1;
  margin-bottom: ${theme.sp.m};
  color: ${theme.colors.navy};
`;

// prettier-ignore
const Name = styled.div`
  ${mixins.paragraphText}
  color: ${theme.colors.royal};
`

// prettier-ignore
const Position = styled.div`
  ${mixins.paragraphText}
  color: ${theme.colors.grey};
`

const propTypes = {
  testimonial: TestimonialType.isRequired,
};

function Testimonial({ testimonial }) {
  return (
    <Wrapper>
      <Logo imageUrl={testimonial.logo.fullSize.src} />
      <Content>{testimonial.testimonial.text}</Content>
      <Name>{testimonial.name}</Name>
      <Position>{testimonial.position}</Position>
    </Wrapper>
  );
}

Testimonial.propTypes = propTypes;

export default Testimonial;



// WEBPACK FOOTER //
// ./src/components/HomePage/components/Testimonials/components/Testimonial.jsx